module.exports = __webpack_public_path__ + "img/team-viktoria.090361be.jpg";